import { Popup } from "react-map-gl";



export const MapPopup = ({ hoverInfo }) => {
  const { latitude, longitude, districtData } = hoverInfo;
  // const totalVotes = districtData.dem + districtData.rep + districtData.other;
  return (
    <Popup
      longitude={longitude}
      latitude={latitude}
      closeButton={false}
      className="county-info"
      closeOnClick={false}
    >
      <div className="popup-content">
        <div className="report">
            <h3>
              Neighborhood: {districtData.NTAName}
            </h3>

            <table className="results">
              <thead>
                <tr>
                  <th>Candidate</th>
                  <th className="number">'20 PCT</th>
                  <th className="number">'24 PCT</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <svg width="16" height="16" transform="translate(0,4)">
                      <circle fill="#325bab" cx="8" cy="8" r="6"></circle>
                    </svg>{" "}
                    Biden/Harris
                  </td>
                  <td className="number">
                    {districtData.dem20_pct
                      ? `${Math.round(districtData.dem20_pct)}%`
                      : "0%"}
                  </td>

                  <td className="number">
                    {districtData.dem_pct
                      ? `${Math.round(districtData.dem_pct)}%`
                      : "0%"}
                  </td>
                </tr>
                <tr>
                  <td>
                    <svg width="16" height="16" transform="translate(0,4)">
                      <circle fill="#d13241" cx="8" cy="8" r="6"></circle>
                    </svg>{" "}
                    Trump
                  </td>
                  <td className="number">
                    {districtData.rep20_pct
                      ? `${Math.round(districtData.rep20_pct)}%`
                      : "0%"}
                  </td>
                  <td className="number">
                    {districtData.rep_pct
                      ? `${Math.round(districtData.rep_pct)}%`
                      : "0%"}
                  </td>
                </tr>
              </tbody>
            </table>
        </div>
      </div>
    </Popup>
  );
};
